import getAttributesImport from '../../settings/attributes'
import getServicesImport from '../../settings/services'
import { launcherSetToken } from '../../launcherBackend/launcher-command'
import { selectors as settingsSelectors } from '../Settings'
import { actions as toasterActions } from '../Toaster'
import { actionLoggerLog } from '../../actions'
import { actions as usersActions, selectors as usersSelectors } from '../Users'
import { selectors as commonTextsSelectors } from '../CommonTexts'

export { ltsLogin } from '../../launcherBackend/lts-service'

export { default as getTexts } from '../../store/localizer'

export const getAttributes = (locale) => {
    const attributes = getAttributesImport(locale)
    return {
        serviceDomains: {
            testing: attributes.service.domains.testing,
            production: attributes.service.domains.production,
        },
        regex: {
            version: attributes.regex.version,
        },
        versionTypes: attributes.launcher.versionTypes,
        defaultServer: attributes.launcher.defaultServer,
    }
}

export const getTokenServices = (locale) => {
    const serv = getServicesImport(locale)
    return {
        testing: serv.token_service.test,
        production: serv.token_service.production,
    }
}

export const actions = {
    showError: toasterActions.addError,
    log: actionLoggerLog,
    logInUser: usersActions.logIn,
}

export const commands = {
    launcherSetToken,
}

export const selectors = {
    getTokens: state => usersSelectors.getTokens(state),
    getAutoLaunchOnLogin: state => settingsSelectors.getAutoLaunchOnLogin(state),
    getAttentionText: state => commonTextsSelectors.getAttentionText(state),
    getErrorText: state => commonTextsSelectors.getErrorText(state),
    getErrorLoginUserText: state => commonTextsSelectors.getErrorLoginUserText(state),
}



// WEBPACK FOOTER //
// ./src/features/Backend/imports.js